import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import React from "react";
import { useUniqueID } from "@xo-union/react-unique-id";
import PropTypes from "prop-types";
const useSingleElementSync = () => {
  const [overwrittenID, setID] = React.useState(undefined);
  const fallbackID = useUniqueID();
  const ref = React.useRef();
  return React.useMemo(() => ({
    ref,
    id: overwrittenID === undefined ? fallbackID : overwrittenID,
    setID
  }), [fallbackID, overwrittenID]);
};
const useElementSyncInit = () => {
  const elements = {
    FocusedOption: useSingleElementSync(),
    Label: useSingleElementSync(),
    ListBox: useSingleElementSync(),
    MenuButton: useSingleElementSync(),
    NativeSelect: useSingleElementSync()
  };
  return React.useMemo(() => elements, _Object$values(elements));
};
const ElementSyncContext = /*#__PURE__*/React.createContext();
export const ElementSyncProvider = _ref => {
  let {
    children
  } = _ref;
  const context = useElementSyncInit();
  return /*#__PURE__*/React.createElement(ElementSyncContext.Provider, {
    value: context
  }, children);
};
process.env.NODE_ENV !== "production" ? ElementSyncProvider.propTypes = {
  children: PropTypes.node
} : void 0;
export const useElementID = elementName => {
  const elements = React.useContext(ElementSyncContext);
  return elements[elementName].id;
};
export const useElementRef = elementName => {
  const elements = React.useContext(ElementSyncContext);
  return elements[elementName].ref;
};
export const useElementIDSync = (elementName, id) => {
  const elements = React.useContext(ElementSyncContext);
  React.useEffect(() => {
    elements[elementName].setID(id);
    return () => {
      elements[elementName].setID('');
    };
  }, [elements, elementName, id]);
  return elements[elementName].id;
};
export const useElementIDAndRefSync = (elementName, id) => {
  const finalID = useElementIDSync(elementName, id);
  const ref = useElementRef(elementName);
  return [finalID, ref];
};